import BaseEntity from '../BaseEntity';
import { IRotatedBoxPure } from '@/editor/types';
import { BoxesOutlineModel as BoxesOutlineModel2d } from '../2d/boxesOutlineModel';
import { BoxesOutlineModel as BoxesOutlineModel3d } from '../3d/boundingBox/boxesOutlineModel';
import { IBoxesEntityParams } from '@/editor/types/entity';

export default class BoxSelectedEntity extends BaseEntity {
  protected override _model2d: BoxesOutlineModel2d;
  protected override _model3d: BoxesOutlineModel3d;
  private _created: boolean = false;

  private _params: IBoxesEntityParams = {
    boxes: [],
    linewidth: 1,
    color: 0x000000,
    x: 0,
    y: 0,
    z: 0,
    rotation: 0,
    renderOrder: undefined
  };

  constructor(renderOrder?: number) {
    super();

    if (renderOrder !== undefined) this._params.renderOrder = renderOrder;
    this._model2d = new BoxesOutlineModel2d();
    this._model3d = new BoxesOutlineModel3d();
  }

  get created() {
    return this._created;
  }

  create(params: {
    boxes: IRotatedBoxPure[];
    linewidth: number;
    color: number;
    x: number;
    y: number;
    z: number;
    rotation: number;
  }) {
    this.clear();
    this._params = { ...params, renderOrder: this._params.renderOrder };

    this._model2d.createModel(this._params);
    this._model3d.createModel(this._params);
    this._created = true;
  }

  override update(params: { x?: number; y?: number; z?: number; rotation?: number }) {
    if (!this._created) return;

    this._params = { ...this._params, ...params };

    this._model2d.update(this._params);
    this._model3d.update(this._params);
  }

  clear() {
    this._model2d.clear();
    this._model3d.clearModel();
    this._created = false;
  }
}
